import { ReactNode } from 'react'
import ModalAction from './ModalAction'
import { Utils } from '../Utils'

const ROOT_RENDER_ID = 'moms-render'

/**
 *  ReactNode 자체를 받아와 root에 렌더링
 */
class MRenderAction extends ModalAction<{ comp: ReactNode; id: string }> {
  // id를 전달하지않으면 전체 제거 (대부분의 경우가 단일)
  destory = (id?: string) => {
    if (!id) {
      this.list = []
    } else {
      const deletedIdx = this.list.findIndex((render) => render.id === id)
      this.list.splice(deletedIdx, 1)
    }

    this.root?.render(this.list.map(({ comp }) => comp))
  }

  show = (comp: ReactNode, id?: string) => {
    this.list.push({ id: id ?? Utils.uuid(), comp })
    this.root?.render(this.list.map(({ comp }) => comp))
  }
}

const MRender = new MRenderAction(ROOT_RENDER_ID)

export default MRender
